/* ============================================================
   Aimrite Article — shortcode renderer
   Parses tokens left in the post body and turns them into live blocks:
     [featured-product="handle"]      -> sidebar featured product
     [collection-carousel="slug"]     -> inline product carousel (arrow nav)
     [tip]...[/tip]                   -> callout box
     [button url="/x"]Label[/button]  -> CTA button
     [related-articles]               -> inline copy of the sidebar related list
   ============================================================ */
(function () {
  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function money(dollars) {
    var n = typeof dollars === 'number' ? dollars : parseFloat(dollars);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }
  function moneyFromCents(c) { return money((c || 0) / 100); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/"/g, '&quot;'); }

  ready(function () {
    var root = document.querySelector('.aim-art');
    if (!root) return;
    var body = root.querySelector('[data-aim-article-body]');
    if (!body) return;

    var featuredHandle = null;
    var html = body.innerHTML;

    // [featured-product="handle"] : remove the whole wrapping paragraph (it may carry an editor note)
    html = html.replace(/<p[^>]*>[\s\S]*?\[featured-product="([^"]+)"\][\s\S]*?<\/p>/i, function (_, h) {
      featuredHandle = h.trim(); return '';
    });
    html = html.replace(/\[featured-product="([^"]+)"\]/i, function (_, h) {
      if (!featuredHandle) featuredHandle = h.trim(); return '';
    });

    // [tip]...[/tip]
    html = html.replace(/(?:<p[^>]*>)?\s*\[tip\]([\s\S]*?)\[\/tip\]\s*(?:<\/p>)?/gi,
      '<div class="aim-art__tip"><p>$1</p></div>');

    // [button url="..."]Label[/button]
    html = html.replace(/(?:<p[^>]*>)?\s*\[button\s+url="([^"]+)"\]([\s\S]*?)\[\/button\]\s*(?:<\/p>)?/gi,
      '<p class="aim-art__btn-wrap"><a class="aim-art__btn" href="$1">$2</a></p>');

    // [collection-carousel="slug"] -> mount
    html = html.replace(/(?:<p[^>]*>)?\s*\[collection-carousel="([^"]+)"\]\s*(?:<\/p>)?/gi,
      '<div class="aim-art__carousel" data-aim-carousel="$1"></div>');

    // [related-articles] -> inline mount
    html = html.replace(/(?:<p[^>]*>)?\s*\[related-articles\]\s*(?:<\/p>)?/gi,
      '<div class="aim-art__related-inline" data-aim-related-inline></div>');

    body.innerHTML = html;

    body.querySelectorAll('[data-aim-carousel]').forEach(function (el) {
      loadCarousel(el, el.getAttribute('data-aim-carousel'));
    });

    // Fill inline related-articles from the sidebar list
    var src = root.querySelector('[data-aim-related-source]');
    if (src) {
      body.querySelectorAll('[data-aim-related-inline]').forEach(function (el) {
        el.innerHTML =
          '<div class="aim-art__widget aim-art__related">' +
          '<div class="aim-art__widget-head">Related articles</div>' +
          '<ul>' + src.innerHTML + '</ul></div>';
      });
    }

    if (featuredHandle) loadFeatured(root, featuredHandle);
  });

  function loadFeatured(root, handle) {
    var mount = root.querySelector('[data-aim-featured]');
    if (!mount) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]);
        var price = p.compare_at_price && p.compare_at_price > p.price
          ? '<s>' + moneyFromCents(p.compare_at_price) + '</s>' + moneyFromCents(p.price)
          : moneyFromCents(p.price);
        mount.innerHTML =
          '<div class="aim-art__widget-head">Featured</div>' +
          '<a class="aim-art__featured-card" href="/products/' + p.handle + '">' +
            (img ? '<div class="aim-art__featured-img"><img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy"></div>' : '') +
            '<div class="aim-art__featured-title">' + p.title + '</div>' +
            '<div class="aim-art__featured-price">' + price + '</div>' +
            '<span class="aim-art__featured-cta">View product</span>' +
          '</a>';
        mount.hidden = false;
      })
      .catch(function () { /* keep Liquid fallback / hidden */ });
  }

  function loadCarousel(el, slug) {
    fetch('/collections/' + slug + '/products.json?limit=12')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { el.remove(); return; }

        var cards = products.map(function (p) {
          var src = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
          var v = (p.variants && p.variants[0]) || {};
          var cmp = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
          var price = cmp > parseFloat(v.price)
            ? '<s>' + money(v.compare_at_price) + '</s>' + money(v.price)
            : money(v.price);
          return '<a class="aim-art__pcard" href="/products/' + p.handle + '">' +
            '<div class="aim-art__pcard-img">' + (src ? '<img src="' + src + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="aim-art__pcard-body">' +
              '<div class="aim-art__pcard-title">' + p.title + '</div>' +
              '<div class="aim-art__pcard-price">' + price + '</div>' +
            '</div></a>';
        }).join('');

        var title = slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        el.innerHTML =
          '<div class="aim-art__carousel-head">' +
            '<h4>' + title + '</h4>' +
            '<div class="aim-art__carousel-nav">' +
              '<a class="aim-art__carousel-shopall" href="/collections/' + slug + '">Shop all &rarr;</a>' +
              '<button type="button" class="aim-art__carousel-arrow" data-dir="prev" aria-label="Previous">' + ARROW_L + '</button>' +
              '<button type="button" class="aim-art__carousel-arrow" data-dir="next" aria-label="Next">' + ARROW_R + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="aim-art__carousel-track">' + cards + '</div>';

        wireCarousel(el);
      })
      .catch(function () { el.remove(); });
  }

  function wireCarousel(el) {
    var track = el.querySelector('.aim-art__carousel-track');
    var prev = el.querySelector('[data-dir="prev"]');
    var next = el.querySelector('[data-dir="next"]');
    if (!track || !prev || !next) return;

    // exactly one card per click (card width + column gap)
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();
